import { defineAsyncComponent, markRaw } from "vue";
import type { TileConfigType } from "@/modules/tiles/tileConfigs";
import { LISAGraphAPI } from "./utils/useOneDrive";

const oneDrive = new LISAGraphAPI();

export const tileConfigs: TileConfigType = {
  OneDriveTile: {
    active: oneDrive.isConfigValid,
    settingsModule: markRaw(
      defineAsyncComponent(() => import("./components/OneDriveTileSettings.vue")),
    ),
    component: markRaw(defineAsyncComponent(() => import("./components/OneDriveTile.vue"))),
    icon: "fas fa-cloud",
  },
};
